export interface RRISettings<T, S> {
  type: T;
  settings: S;
}
